export default "__VITE_ASSET__5d08589e__"